window.addEventListener("load", function () {
  console.log("Script loaded");

  const modal = document.getElementById("imgModal-product-block-complementary");
  const modalImg = document.getElementById("modalImage-product-block-complementary");
  const closeBtn = document.getElementById("closeModal-product-block-complementary");
  const img = document.getElementById("openModal-product-block-complementary");

  if (img && modal && modalImg) {
    img.addEventListener("click", function () {
      modal.style.display = "block";
      modalImg.src = this.currentSrc || this.src;
      modalImg.alt = this.alt;
      console.log("Image clicked");
    });
  }

  if (closeBtn && modal) {
    closeBtn.addEventListener("click", function () {
      modal.style.display = "none";
    });
  }

  window.addEventListener("click", function (e) {
    if (modal && e.target === modal) {
      modal.style.display = "none";
    }
  });
});
